var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#ff5cd1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-icon2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_3",
    "data-name": "38 copia 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.05,117.42l-.06-.06,12.81-12.81,14.75-2.23a4.67,4.67,0,0,0,2.64-1.33l10.12-10.13a4.81,4.81,0,0,0,1.24-2.15l3.82-14.59a4.74,4.74,0,0,0-1.22-4.55L175,65.4a4.76,4.76,0,0,0-3.35-1.4h0a4.73,4.73,0,0,0-3.35,1.39l-11.4,11.38L155.07,75l11.38-11.39a4.74,4.74,0,0,0,0-6.7l-4-4a4.74,4.74,0,0,0-3.35-1.39,4.52,4.52,0,0,0-1.21.16l-14.58,3.83a4.71,4.71,0,0,0-2.14,1.23L131.05,66.86a4.69,4.69,0,0,0-1.34,2.64L127.53,84l-13,13L101.81,84.18,99.59,69.43a4.78,4.78,0,0,0-1.34-2.64L88.12,56.67A4.79,4.79,0,0,0,86,55.44L71.38,51.61a4.93,4.93,0,0,0-1.2-.15,4.72,4.72,0,0,0-3.34,1.37L62.66,57a4.72,4.72,0,0,0,0,6.7L74,75.1l-1.82,1.81L60.83,65.53a4.76,4.76,0,0,0-6.7,0l-4,4a4.73,4.73,0,0,0-1.23,4.55l3.83,14.58A4.89,4.89,0,0,0,54,90.79l10.14,10.14a4.69,4.69,0,0,0,2.64,1.34l14.47,2.18,12.91,12.91L53,158.56A14.44,14.44,0,1,0,73.37,179l41.2-41.2L155.82,179a14.44,14.44,0,1,0,20.43-20.42ZM83.48,100l-16-2.41L57.33,87.44,53.5,72.86l4-4L72.22,83.61l8.51-8.51L66,60.35l4.18-4.16L84.77,60,94.9,70.14l2.42,16-.12.12,14,14L97.49,114ZM70,175.64a9.7,9.7,0,0,1-13.71-13.73l44.15-44.16a4.59,4.59,0,0,0,.41-.36l13.72-13.73a2.93,2.93,0,0,0,.37-.42l17-17,2.42-16,10.14-10.14,14.59-3.83,4,4L148.37,75l8.51,8.51,14.76-14.73,4.15,4.17L172,87.51,161.84,97.64l-16,2.42-.12-.12-24.28,24.28L114.54,131a4.75,4.75,0,0,0-.57.69Zm102.88,0a9.69,9.69,0,0,1-13.73,0l-41.25-41.24,6.85-6.86,6.93-6.81L172.9,162A9.7,9.7,0,0,1,172.9,175.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.65,162.61a5.54,5.54,0,1,1-7.83,0A5.55,5.55,0,0,1,167.65,162.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.37,170.39a5.54,5.54,0,1,1,0-7.83A5.54,5.54,0,0,1,69.37,170.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIcon2);
export default __webpack_public_path__ + "static/media/ic-icon2.e17cf0dc53c7c7e313ecc26eb9f380b2.svg";
export { ForwardRef as ReactComponent };